<template>
  <div :class="{
    'opacity-6': $store.state.spinner
  }">
    <router-view />
  </div>

  <div class="spinner d-flex justify-content-center align-items-center" v-if="$store.state.spinner">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>


